export const DOWNLOADS_LIST_QUERY_KEY = ["downloads"];
